module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-unactive@2x-a88baad3.png";